```vue
<template>
  <transition name="reward-stage">
    <div
      v-if="visible"
      class="reward-stage"
      @click.self="close"
    >

      <!-- =====================================================
           背景
      ====================================================== -->

      <div class="stage-bg"></div>

      <!-- 黑色四周暗角 -->
      <div class="stage-vignette"></div>

      <!-- 背景星星 -->
      <div class="background-stars">
        <i
          v-for="n in 25"
          :key="'star-' + n"
          :class="'star star-' + n"
        ></i>
      </div>


      <!-- =====================================================
           中央能量
      ====================================================== -->

      <div class="energy-system">

        <!-- 外层能量 -->
        <div class="energy energy-outer"></div>

        <!-- 中层能量 -->
        <div class="energy energy-middle"></div>

        <!-- 内层能量 -->
        <div class="energy energy-inner"></div>

        <!-- 中心亮点 -->
        <div class="energy-core"></div>

      </div>


      <!-- =====================================================
           放射光线
      ====================================================== -->

      <div class="rays rays-1"></div>

      <div class="rays rays-2"></div>

      <div class="rays rays-3"></div>


      <!-- =====================================================
           光环
      ====================================================== -->

      <div
        class="ring ring-1"
        :class="{ active: stage >= 3 }"
      ></div>

      <div
        class="ring ring-2"
        :class="{ active: stage >= 3 }"
      ></div>

      <div
        class="ring ring-3"
        :class="{ active: stage >= 3 }"
      ></div>


      <!-- =====================================================
           卡牌
      ====================================================== -->

      <div
        class="card-scene"
        :class="{
          'card-fly': stage >= 1,
          'card-flip': stage >= 2,
          'card-reveal': stage >= 3
        }"
      >

        <div class="card">

          <!-- ===============================
               卡牌背面
          ================================ -->

          <div class="card-face card-back">

            <!-- 外框 -->
            <div class="card-back-border"></div>

            <!-- 第二层边框 -->
            <div class="card-back-border inner"></div>

            <!-- 中央菱形 -->
            <div class="card-back-diamond">

              <div class="diamond diamond-1"></div>

              <div class="diamond diamond-2"></div>

              <div class="diamond diamond-3"></div>

              <div class="diamond-symbol">
                ✦
              </div>

            </div>

            <!-- 卡牌背面光 -->
            <div class="card-back-light"></div>

            <!-- 四角装饰 -->

            <span class="corner corner-tl"></span>

            <span class="corner corner-tr"></span>

            <span class="corner corner-bl"></span>

            <span class="corner corner-br"></span>

          </div>


          <!-- ===============================
               卡牌正面
          ================================ -->

          <div class="card-face card-front">

            <!-- 顶部稀有度 -->
            <div class="card-rarity">
              <span class="rarity-line"></span>

              <span>
                {{ reward.rarity || 'LEGENDARY' }}
              </span>

              <span class="rarity-line"></span>
            </div>


            <!-- 图片区域 -->
            <div class="card-image">

              <!-- 图片后面的光 -->
              <div class="image-light"></div>

              <!-- 光圈 -->
              <div class="image-ring"></div>

              <!-- 奖励图片 -->
              <img
                v-if="reward.image"
                :src="reward.image"
                :alt="reward.name"
                class="reward-image"
              />

              <!-- 没有图片的时候 -->
              <div
                v-else
                class="reward-default"
              >
                🎁
              </div>

            </div>


            <!-- 卡牌底部渐变 -->
            <div class="card-bottom-gradient"></div>


            <!-- 卡牌名称 -->
            <div class="card-name">
              {{ reward.name }}
            </div>


            <!-- 数量 -->
            <div class="card-count">
              × {{ reward.count || 1 }}
            </div>


            <!-- 卡牌装饰线 -->
            <div class="card-decoration">

              <span></span>

              <i>✦</i>

              <span></span>

            </div>

          </div>

        </div>

      </div>


      <!-- =====================================================
           爆炸粒子
      ====================================================== -->

      <div
        class="particle-container"
        :class="{ active: stage >= 3 }"
      >

        <i
          v-for="n in 40"
          :key="'particle-' + n"
          :class="'particle particle-' + n"
          :style="getParticleStyle(n)"
        ></i>

      </div>


      <!-- =====================================================
           星屑
      ====================================================== -->

      <div
        class="spark-container"
        :class="{ active: stage >= 3 }"
      >

        <i
          v-for="n in 18"
          :key="'spark-' + n"
          :class="'spark spark-' + n"
        ></i>

      </div>


      <!-- =====================================================
           屏幕爆闪
      ====================================================== -->

      <div
        class="screen-flash"
        :class="{ active: stage >= 3 }"
      ></div>


      <!-- =====================================================
           中央冲击波
      ====================================================== -->

      <div
        class="shockwave"
        :class="{ active: stage >= 3 }"
      ></div>


      <!-- 第二层冲击波 -->
      <div
        class="shockwave shockwave-2"
        :class="{ active: stage >= 3 }"
      ></div>


      <!-- =====================================================
           奖励文字
      ====================================================== -->

      <div
        class="reward-info"
        :class="{ active: stage >= 3 }"
      >

        <!-- 稀有奖励 -->
        <div class="reward-subtitle">

          <span>✦</span>

          <span>
            {{ reward.subtitle || 'RARE REWARD' }}
          </span>

          <span>✦</span>

        </div>


        <!-- 奖励名称 -->
        <div class="reward-title">
          {{ reward.name }}
        </div>


        <!-- 数量 -->
        <div class="reward-number">
          × {{ reward.count || 1 }}
        </div>


        <!-- 确定按钮 -->
        <button
          class="confirm-btn"
          type="button"
          @click="close"
        >

          <span class="btn-border"></span>

          <span class="btn-text">
            确 定
          </span>

          <span class="btn-shine"></span>

        </button>

      </div>


      <!-- =====================================================
           跳过
      ====================================================== -->

      <div
        v-if="stage < 3"
        class="skip"
        @click.stop="skipAnimation"
      >
        <span>点击跳过</span>
      </div>

    </div>
  </transition>
</template>


<script>
export default {
  name: 'RewardCardEffect',

  props: {

    /**
     * v-model
     */
    value: {
      type: Boolean,
      default: false
    },

    /**
     * 奖励数据
     *
     * {
     *   name: '传说宝箱',
     *   image: '',
     *   count: 1,
     *   rarity: 'LEGENDARY',
     *   subtitle: 'RARE REWARD'
     * }
     */
    reward: {
      type: Object,
      default() {
        return {
          name: '神秘奖励',
          image: '',
          count: 1,
          rarity: 'LEGENDARY',
          subtitle: 'RARE REWARD'
        }
      }
    }

  },

  data() {
    return {

      /**
       * 是否显示
       */
      visible: false,

      /**
       * 动画阶段
       *
       * 0 = 初始
       * 1 = 卡牌飞入
       * 2 = 翻牌
       * 3 = 奖励揭晓
       */
      stage: 0,

      /**
       * 定时器
       */
      timers: []

    }
  },

  watch: {

    value: {
      immediate: true,

      handler(val) {

        if (val) {
          this.play()
        } else {
          this.reset()
        }

      }
    }

  },

  methods: {

    /**
     * 开始播放
     */
    play() {

      this.clearTimers()

      this.visible = true

      this.stage = 0

      /**
       * 第一阶段
       *
       * 卡牌开始飞入
       */
      this.timers.push(
        setTimeout(() => {

          this.stage = 1

        }, 50)
      )


      /**
       * 第二阶段
       *
       * 卡牌翻面
       */
      this.timers.push(
        setTimeout(() => {

          this.stage = 2

        }, 1150)
      )


      /**
       * 第三阶段
       *
       * 爆闪 + 粒子 + 奖励信息
       */
      this.timers.push(
        setTimeout(() => {

          this.stage = 3

        }, 1800)
      )

    },


    /**
     * 跳过动画
     */
    skipAnimation() {

      this.clearTimers()

      this.stage = 3

    },


    /**
     * 关闭
     */
    close() {

      this.clearTimers()

      this.$emit('input', false)

      this.$emit('close')

    },


    /**
     * 重置
     */
    reset() {

      this.clearTimers()

      this.visible = false

      this.stage = 0

    },


    /**
     * 清理定时器
     */
    clearTimers() {

      this.timers.forEach(timer => {

        clearTimeout(timer)

      })

      this.timers = []

    },


    /**
     * 生成粒子随机位置
     */
    getParticleStyle(index) {

      const angle =
        (360 / 40) * index

      const distance =
        220 + Math.random() * 420

      const size =
        3 + Math.random() * 7

      const delay =
        Math.random() * 0.15

      return {

        '--angle': `${angle}deg`,

        '--distance': `${distance}px`,

        '--size': `${size}px`,

        '--delay': `${delay}s`

      }

    }

  },


  beforeDestroy() {

    this.clearTimers()

  }

}
</script>


<style lang="less" scoped>

/* =========================================================
   根容器
========================================================= */

.reward-stage {

  position: fixed;

  left: 0;
  top: 0;

  width: 100vw;
  height: 100vh;

  z-index: 999999;

  overflow: hidden;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #030305;

  perspective: 1400px;

  user-select: none;

}


/* =========================================================
   背景
========================================================= */

.stage-bg {

  position: absolute;

  inset: 0;

  background:

    radial-gradient(
      circle at 50% 45%,
      rgba(92, 68, 20, 0.3),
      rgba(15, 12, 5, 0.7) 38%,
      rgba(0, 0, 0, 0.98) 80%
    );

}


/* =========================================================
   四周暗角
========================================================= */

.stage-vignette {

  position: absolute;

  inset: 0;

  z-index: 5;

  pointer-events: none;

  background:

    radial-gradient(
      circle at center,
      transparent 25%,
      rgba(0, 0, 0, 0.35) 50%,
      rgba(0, 0, 0, 0.9) 100%
    );

}


/* =========================================================
   背景星星
========================================================= */

.background-stars {

  position: absolute;

  inset: 0;

  z-index: 2;

  pointer-events: none;

}


.star {

  position: absolute;

  width: 2px;
  height: 2px;

  border-radius: 50%;

  background: rgba(255, 235, 160, 0.8);

  box-shadow:
    0 0 5px rgba(255, 220, 120, 0.9);

  opacity: 0;

  animation:
    star-twinkle
    2s
    ease-in-out
    infinite;

}


/* 随机位置 */

.star-1 { left: 8%; top: 18%; animation-delay: .1s; }
.star-2 { left: 16%; top: 35%; animation-delay: .5s; }
.star-3 { left: 22%; top: 12%; animation-delay: .8s; }
.star-4 { left: 28%; top: 72%; animation-delay: .3s; }
.star-5 { left: 35%; top: 20%; animation-delay: 1s; }
.star-6 { left: 42%; top: 10%; animation-delay: .4s; }
.star-7 { left: 50%; top: 17%; animation-delay: .7s; }
.star-8 { left: 59%; top: 12%; animation-delay: .2s; }
.star-9 { left: 66%; top: 30%; animation-delay: .9s; }
.star-10 { left: 75%; top: 18%; animation-delay: .4s; }
.star-11 { left: 84%; top: 36%; animation-delay: .6s; }
.star-12 { left: 91%; top: 16%; animation-delay: 1.2s; }
.star-13 { left: 12%; top: 67%; animation-delay: .8s; }
.star-14 { left: 20%; top: 82%; animation-delay: .2s; }
.star-15 { left: 32%; top: 88%; animation-delay: .6s; }
.star-16 { left: 69%; top: 80%; animation-delay: .4s; }
.star-17 { left: 79%; top: 72%; animation-delay: .9s; }
.star-18 { left: 90%; top: 85%; animation-delay: .3s; }
.star-19 { left: 5%; top: 50%; animation-delay: 1.1s; }
.star-20 { left: 95%; top: 52%; animation-delay: .7s; }
.star-21 { left: 18%; top: 50%; animation-delay: .5s; }
.star-22 { left: 82%; top: 48%; animation-delay: .8s; }
.star-23 { left: 44%; top: 92%; animation-delay: .1s; }
.star-24 { left: 56%; top: 90%; animation-delay: .9s; }
.star-25 { left: 97%; top: 25%; animation-delay: .3s; }


@keyframes star-twinkle {

  0%,
  100% {
    opacity: 0;
    transform: scale(0.5);
  }

  50% {
    opacity: 1;
    transform: scale(1.8);
  }

}


/* =========================================================
   中央能量系统
========================================================= */

.energy-system {

  position: absolute;

  left: 50%;
  top: 50%;

  z-index: 4;

  width: 1px;
  height: 1px;

}


.energy {

  position: absolute;

  left: 50%;
  top: 50%;

  transform:
    translate(-50%, -50%);

  border-radius: 50%;

  pointer-events: none;

}


.energy-outer {

  width: 680px;
  height: 680px;

  background:

    radial-gradient(
      circle,
      rgba(255, 194, 45, 0.08),
      transparent 65%
    );

  filter: blur(25px);

  animation:
    energy-outer
    3s
    ease-in-out
    infinite;

}


.energy-middle {

  width: 420px;
  height: 420px;

  background:

    radial-gradient(
      circle,
      rgba(255, 218, 100, 0.15),
      transparent 68%
    );

  filter: blur(15px);

  animation:
    energy-middle
    2.2s
    ease-in-out
    infinite;

}


.energy-inner {

  width: 240px;
  height: 240px;

  background:

    radial-gradient(
      circle,
      rgba(255, 235, 150, 0.4),
      rgba(255, 170, 20, 0.08),
      transparent 70%
    );

  filter: blur(10px);

  animation:
    energy-inner
    1.5s
    ease-in-out
    infinite;

}


.energy-core {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 80px;
  height: 80px;

  transform:
    translate(-50%, -50%);

  border-radius: 50%;

  background:

    radial-gradient(
      circle,
      #fff 0%,
      #fff5bc 20%,
      #ffc928 45%,
      rgba(255, 177, 0, 0.3) 65%,
      transparent 75%
    );

  filter: blur(4px);

  animation:
    core-pulse
    1s
    ease-in-out
    infinite;

}


@keyframes energy-outer {

  0%,
  100% {
    transform:
      translate(-50%, -50%)
      scale(0.85);

    opacity: 0.4;
  }

  50% {
    transform:
      translate(-50%, -50%)
      scale(1.1);

    opacity: 0.9;
  }

}


@keyframes energy-middle {

  0%,
  100% {
    transform:
      translate(-50%, -50%)
      scale(0.8);
  }

  50% {
    transform:
      translate(-50%, -50%)
      scale(1.15);
  }

}


@keyframes energy-inner {

  0%,
  100% {
    transform:
      translate(-50%, -50%)
      scale(0.85);
  }

  50% {
    transform:
      translate(-50%, -50%)
      scale(1.2);
  }

}


@keyframes core-pulse {

  0%,
  100% {
    transform:
      translate(-50%, -50%)
      scale(0.8);

    opacity: 0.6;
  }

  50% {
    transform:
      translate(-50%, -50%)
      scale(1.3);

    opacity: 1;
  }

}


/* =========================================================
   放射光
========================================================= */

.rays {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 1200px;
  height: 1200px;

  z-index: 3;

  transform:
    translate(-50%, -50%);

  pointer-events: none;

  background:

    repeating-conic-gradient(
      from 0deg,
      rgba(255, 222, 110, 0.15) 0deg 4deg,
      transparent 4deg 12deg
    );

  mask-image:

    radial-gradient(
      circle,
      #000 0%,
      rgba(0, 0, 0, 0.8) 38%,
      transparent 72%
    );

}


.rays-1 {

  animation:
    rays-rotate
    18s
    linear
    infinite;

}


.rays-2 {

  width: 950px;
  height: 950px;

  opacity: 0.65;

  transform:
    translate(-50%, -50%)
    rotate(15deg);

  animation:
    rays-reverse
    12s
    linear
    infinite;

}


.rays-3 {

  width: 700px;
  height: 700px;

  opacity: 0.45;

  animation:
    rays-rotate
    8s
    linear
    infinite;

}


@keyframes rays-rotate {

  from {
    transform:
      translate(-50%, -50%)
      rotate(0deg);
  }

  to {
    transform:
      translate(-50%, -50%)
      rotate(360deg);
  }

}


@keyframes rays-reverse {

  from {
    transform:
      translate(-50%, -50%)
      rotate(360deg);
  }

  to {
    transform:
      translate(-50%, -50%)
      rotate(0deg);
  }

}


/* =========================================================
   光环
========================================================= */

.ring {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 200px;
  height: 200px;

  z-index: 12;

  border-radius: 50%;

  border:
    2px solid
    rgba(255, 220, 100, 0.8);

  transform:
    translate(-50%, -50%)
    scale(0);

  opacity: 0;

  pointer-events: none;

}


.ring.active {

  animation:
    ring-expand
    1.2s
    cubic-bezier(
      0.16,
      1,
      0.3,
      1
    )
    forwards;

}


.ring-2 {
  width: 280px;
  height: 280px;

  animation-delay: .12s;
}


.ring-3 {
  width: 360px;
  height: 360px;

  animation-delay: .24s;
}


@keyframes ring-expand {

  0% {

    opacity: 1;

    transform:
      translate(-50%, -50%)
      scale(0.2);
  }

  100% {

    opacity: 0;

    transform:
      translate(-50%, -50%)
      scale(6);
  }

}


/* =========================================================
   卡牌场景
========================================================= */

.card-scene {

  position: relative;

  z-index: 20;

  width: 300px;
  height: 430px;

  transform-style: preserve-3d;

  opacity: 0;

}


/* =========================================================
   卡牌飞入
========================================================= */

.card-fly {

  animation:

    card-enter

    1.1s

    cubic-bezier(
      0.16,
      1,
      0.3,
      1
    )

    forwards;

}


@keyframes card-enter {

  0% {

    opacity: 0;

    transform:

      translateY(90vh)

      translateZ(-700px)

      rotateX(60deg)

      rotateY(-1080deg)

      rotateZ(-30deg)

      scale(0.12);

  }


  20% {

    opacity: 1;

  }


  55% {

    transform:

      translateY(-60px)

      translateZ(120px)

      rotateX(18deg)

      rotateY(-100deg)

      rotateZ(8deg)

      scale(1.12);

  }


  75% {

    transform:

      translateY(15px)

      translateZ(20px)

      rotateX(4deg)

      rotateY(30deg)

      rotateZ(-4deg)

      scale(0.97);

  }


  90% {

    transform:

      translateY(-8px)

      translateZ(0)

      rotateX(0)

      rotateY(-8deg)

      rotateZ(2deg)

      scale(1.02);

  }


  100% {

    opacity: 1;

    transform:

      translateY(0)

      translateZ(0)

      rotateX(0)

      rotateY(0)

      rotateZ(0)

      scale(1);

  }

}


/* =========================================================
   卡牌本体
========================================================= */

.card {

  position: relative;

  width: 100%;
  height: 100%;

  transform-style: preserve-3d;

  transition:

    transform

    0.65s

    cubic-bezier(
      0.22,
      1,
      0.36,
      1
    );

}


/* =========================================================
   翻牌
========================================================= */

.card-flip .card {

  transform:
    rotateY(180deg);

}


/* =========================================================
   卡牌面
========================================================= */

.card-face {

  position: absolute;

  inset: 0;

  border-radius: 22px;

  overflow: hidden;

  backface-visibility: hidden;

  transform-style: preserve-3d;

}


/* =========================================================
   卡牌背面
========================================================= */

.card-back {

  background:

    radial-gradient(
      circle at center,
      rgba(255, 235, 150, 0.3),
      transparent 30%
    ),

    linear-gradient(
      145deg,
      #49360f,
      #171004 55%,
      #080602
    );

  border:
    3px solid
    rgba(255, 224, 130, 0.9);

  box-shadow:

    0 0 15px
    rgba(255, 225, 130, 0.9),

    0 0 50px
    rgba(255, 180, 30, 0.6),

    0 0 100px
    rgba(255, 150, 0, 0.3),

    inset 0 0 40px
    rgba(255, 220, 100, 0.18);

}


/* =========================================================
   卡牌背面边框
========================================================= */

.card-back-border {

  position: absolute;

  inset: 12px;

  border:
    1px solid
    rgba(255, 239, 175, 0.8);

  border-radius: 15px;

}


.card-back-border.inner {

  inset: 20px;

  border:
    1px solid
    rgba(255, 205, 80, 0.4);

  border-radius: 12px;

}


/* =========================================================
   中央菱形
========================================================= */

.card-back-diamond {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 180px;
  height: 180px;

  transform:
    translate(-50%, -50%)
    rotate(45deg);

}


.diamond {

  position: absolute;

  left: 50%;
  top: 50%;

  border:
    1px solid
    rgba(255, 230, 140, 0.65);

  transform:
    translate(-50%, -50%);

}


.diamond-1 {

  width: 170px;
  height: 170px;

}


.diamond-2 {

  width: 125px;
  height: 125px;

}


.diamond-3 {

  width: 80px;
  height: 80px;

  border-color:
    rgba(255, 245, 190, 0.9);

}


/* =========================================================
   中央符号
========================================================= */

.diamond-symbol {

  position: absolute;

  left: 50%;
  top: 50%;

  transform:
    translate(-50%, -50%)
    rotate(-45deg);

  font-size: 72px;

  color: #ffe89b;

  text-shadow:

    0 0 8px #fff,

    0 0 25px #ffd33d,

    0 0 60px #ff9f00;

  animation:

    symbol-rotate

    3s

    linear

    infinite;

}


@keyframes symbol-rotate {

  0% {
    transform:
      translate(-50%, -50%)
      rotate(-45deg);
  }

  100% {
    transform:
      translate(-50%, -50%)
      rotate(315deg);
  }

}


/* =========================================================
   卡牌背面光
========================================================= */

.card-back-light {

  position: absolute;

  left: -100%;

  top: -20%;

  width: 60%;
  height: 150%;

  transform:
    rotate(20deg);

  background:

    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );

  animation:

    card-light

    2s

    infinite;

}


@keyframes card-light {

  0% {
    left: -100%;
  }

  45%,
  100% {
    left: 150%;
  }

}


/* =========================================================
   四角
========================================================= */

.corner {

  position: absolute;

  width: 35px;
  height: 35px;

  border-color:
    rgba(255, 232, 150, 0.9);

}


.corner-tl {

  left: 17px;
  top: 17px;

  border-left: 2px solid;
  border-top: 2px solid;

}


.corner-tr {

  right: 17px;
  top: 17px;

  border-right: 2px solid;
  border-top: 2px solid;

}


.corner-bl {

  left: 17px;
  bottom: 17px;

  border-left: 2px solid;
  border-bottom: 2px solid;

}


.corner-br {

  right: 17px;
  bottom: 17px;

  border-right: 2px solid;
  border-bottom: 2px solid;

}


/* =========================================================
   卡牌正面
========================================================= */

.card-front {

  transform:
    rotateY(180deg);

  display: flex;

  flex-direction: column;

  align-items: center;

  background:

    radial-gradient(
      circle at 50% 25%,
      rgba(255, 235, 150, 0.4),
      transparent 35%
    ),

    linear-gradient(
      180deg,
      #57400e,
      #211705 55%,
      #0d0903
    );

  border:
    3px solid
    #f7d77a;

  box-shadow:

    0 0 15px
    rgba(255, 240, 180, 1),

    0 0 40px
    rgba(255, 190, 30, 0.85),

    0 0 100px
    rgba(255, 150, 0, 0.55),

    inset 0 0 40px
    rgba(255, 225, 120, 0.25);

}


/* =========================================================
   稀有度
========================================================= */

.card-rarity {

  position: relative;

  z-index: 5;

  margin-top: 22px;

  display: flex;

  align-items: center;

  gap: 12px;

  font-size: 13px;

  font-weight: 700;

  letter-spacing: 5px;

  color: #ffe89b;

  text-shadow:

    0 0 8px #fff,

    0 0 20px #ffc400;

}


.rarity-line {

  width: 35px;

  height: 1px;

  background:

    linear-gradient(
      90deg,
      transparent,
      #ffe79a
    );

}


.rarity-line:last-child {

  transform:
    rotate(180deg);

}


/* =========================================================
   图片
========================================================= */

.card-image {

  position: relative;

  width: 235px;
  height: 235px;

  margin-top: 18px;

  display: flex;

  align-items: center;

  justify-content: center;

}


.image-light {

  position: absolute;

  width: 190px;
  height: 190px;

  border-radius: 50%;

  background:

    radial-gradient(
      circle,
      rgba(255, 239, 165, 0.8),
      rgba(255, 184, 20, 0.3) 40%,
      transparent 72%
    );

  filter: blur(12px);

  animation:

    image-light

    1.5s

    ease-in-out

    infinite;

}


@keyframes image-light {

  0%,
  100% {

    transform: scale(0.85);

    opacity: 0.55;

  }

  50% {

    transform: scale(1.15);

    opacity: 1;

  }

}


/* =========================================================
   图片光圈
========================================================= */

.image-ring {

  position: absolute;

  width: 180px;
  height: 180px;

  border-radius: 50%;

  border:

    1px solid
    rgba(255, 238, 170, 0.75);

  box-shadow:

    0 0 15px
    rgba(255, 220, 100, 0.6),

    inset 0 0 15px
    rgba(255, 220, 100, 0.5);

  animation:

    image-ring

    3s

    linear

    infinite;

}


@keyframes image-ring {

  from {

    transform:
      rotate(0deg);

  }

  to {

    transform:
      rotate(360deg);

  }

}


/* =========================================================
   奖励图片
========================================================= */

.reward-image {

  position: relative;

  z-index: 5;

  width: 185px;
  height: 185px;

  object-fit: contain;

  filter:

    drop-shadow(
      0 12px 15px
      rgba(0, 0, 0, 0.5)
    )

    drop-shadow(
      0 0 15px
      rgba(255, 220, 90, 0.5)
    );

}


/* =========================================================
   默认奖励
========================================================= */

.reward-default {

  position: relative;

  z-index: 5;

  font-size: 95px;

  filter:

    drop-shadow(
      0 10px 15px
      rgba(0, 0, 0, 0.5)
    );

}


/* =========================================================
   卡牌底部渐变
========================================================= */

.card-bottom-gradient {

  position: absolute;

  left: 0;
  right: 0;

  bottom: 0;

  height: 110px;

  background:

    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75),
      transparent
    );

}


/* =========================================================
   卡牌名称
========================================================= */

.card-name {

  position: relative;

  z-index: 6;

  margin-top: -18px;

  font-size: 24px;

  font-weight: 900;

  color: #fff;

  text-shadow:

    0 0 8px #fff,

    0 0 20px #ffd94a,

    0 0 40px #ff9e00;

}


/* =========================================================
   卡牌数量
========================================================= */

.card-count {

  position: relative;

  z-index: 6;

  margin-top: 4px;

  font-size: 18px;

  font-weight: 700;

  color: #ffe8a0;

}


/* =========================================================
   装饰线
========================================================= */

.card-decoration {

  position: relative;

  z-index: 6;

  display: flex;

  align-items: center;

  gap: 8px;

  margin-top: 5px;

}


.card-decoration span {

  width: 35px;

  height: 1px;

  background:

    linear-gradient(
      90deg,
      transparent,
      rgba(255, 225, 140, 0.8)
    );

}


.card-decoration span:last-child {

  transform:
    rotate(180deg);

}


.card-decoration i {

  font-style: normal;

  font-size: 10px;

  color: #ffe79a;

}


/* =========================================================
   粒子容器
========================================================= */

.particle-container {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 1px;
  height: 1px;

  z-index: 35;

  pointer-events: none;

}


/* =========================================================
   粒子
========================================================= */

.particle {

  position: absolute;

  left: 0;
  top: 0;

  width: var(--size);
  height: var(--size);

  border-radius: 50%;

  background: #fff;

  box-shadow:

    0 0 6px #fff,

    0 0 15px #ffd64d,

    0 0 30px #ff9d00;

  opacity: 0;

}


.particle-container.active .particle {

  animation:

    particle-explode

    1.3s

    var(--delay)

    cubic-bezier(
      0.16,
      1,
      0.3,
      1
    )

    forwards;

}


@keyframes particle-explode {

  0% {

    opacity: 0;

    transform:

      rotate(var(--angle))

      translateX(0)

      scale(0);

  }

  12% {

    opacity: 1;

    transform:

      rotate(var(--angle))

      translateX(25px)

      scale(1.2);

  }

  100% {

    opacity: 0;

    transform:

      rotate(var(--angle))

      translateX(var(--distance))

      scale(0.15);

  }

}


/* =========================================================
   星屑
========================================================= */

.spark-container {

  position: absolute;

  inset: 0;

  z-index: 34;

  pointer-events: none;

}


.spark {

  position: absolute;

  width: 5px;
  height: 5px;

  border-radius: 50%;

  background: #fff;

  box-shadow:

    0 0 8px #fff,

    0 0 20px #ffd54a;

  opacity: 0;

}


.spark-container.active .spark {

  animation:

    spark-float

    2s

    ease-in-out

    infinite;

}


.spark-1 { left: 15%; top: 35%; animation-delay: .1s; }
.spark-2 { left: 21%; top: 52%; animation-delay: .4s; }
.spark-3 { left: 28%; top: 27%; animation-delay: .8s; }
.spark-4 { left: 33%; top: 68%; animation-delay: .2s; }
.spark-5 { left: 39%; top: 18%; animation-delay: .7s; }
.spark-6 { left: 44%; top: 75%; animation-delay: .3s; }
.spark-7 { left: 48%; top: 28%; animation-delay: .9s; }
.spark-8 { left: 55%; top: 15%; animation-delay: .4s; }
.spark-9 { left: 60%; top: 78%; animation-delay: .6s; }
.spark-10 { left: 67%; top: 25%; animation-delay: .2s; }
.spark-11 { left: 72%; top: 65%; animation-delay: .8s; }
.spark-12 { left: 79%; top: 38%; animation-delay: .3s; }
.spark-13 { left: 85%; top: 55%; animation-delay: .9s; }
.spark-14 { left: 91%; top: 32%; animation-delay: .5s; }
.spark-15 { left: 11%; top: 72%; animation-delay: .7s; }
.spark-16 { left: 25%; top: 82%; animation-delay: .1s; }
.spark-17 { left: 75%; top: 83%; animation-delay: .4s; }
.spark-18 { left: 88%; top: 75%; animation-delay: .8s; }


@keyframes spark-float {

  0%,
  100% {

    opacity: 0;

    transform:
      translateY(10px)
      scale(0.5);

  }

  50% {

    opacity: 1;

    transform:
      translateY(-25px)
      scale(1.4);

  }

}


/* =========================================================
   屏幕爆闪
========================================================= */

.screen-flash {

  position: absolute;

  inset: 0;

  z-index: 45;

  pointer-events: none;

  background: #fff;

  opacity: 0;

}


.screen-flash.active {

  animation:

    screen-flash

    0.6s

    ease-out

    forwards;

}


@keyframes screen-flash {

  0% {
    opacity: 0;
  }

  10% {
    opacity: 0.95;
  }

  22% {
    opacity: 0.3;
  }

  40% {
    opacity: 0.08;
  }

  100% {
    opacity: 0;
  }

}


/* =========================================================
   冲击波
========================================================= */

.shockwave {

  position: absolute;

  left: 50%;
  top: 50%;

  width: 80px;
  height: 80px;

  z-index: 32;

  border-radius: 50%;

  border:

    3px solid
    rgba(255, 236, 160, 0.95);

  box-shadow:

    0 0 15px
    rgba(255, 225, 100, 0.8);

  opacity: 0;

  transform:

    translate(-50%, -50%)
    scale(0);

}


.shockwave.active {

  animation:

    shockwave

    1.1s

    cubic-bezier(
      0.16,
      1,
      0.3,
      1
    )

    forwards;

}


.shockwave-2 {

  width: 120px;
  height: 120px;

}


.shockwave-2.active {

  animation-delay: .12s;

}


@keyframes shockwave {

  0% {

    opacity: 1;

    transform:

      translate(-50%, -50%)
      scale(0);

  }

  100% {

    opacity: 0;

    transform:

      translate(-50%, -50%)
      scale(10);

  }

}


/* =========================================================
   奖励信息
========================================================= */

.reward-info {

  position: absolute;

  left: 50%;

  top: calc(50% + 270px);

  z-index: 50;

  width: 600px;

  text-align: center;

  opacity: 0;

  transform:

    translateX(-50%)
    translateY(40px)
    scale(0.7);

  pointer-events: none;

}


.reward-info.active {

  animation:

    reward-info-show

    0.7s

    0.15s

    cubic-bezier(
      0.16,
      1,
      0.3,
      1
    )

    forwards;

  pointer-events: auto;

}


@keyframes reward-info-show {

  0% {

    opacity: 0;

    transform:

      translateX(-50%)
      translateY(50px)
      scale(0.7);

  }

  70% {

    opacity: 1;

    transform:

      translateX(-50%)
      translateY(-5px)
      scale(1.04);

  }

  100% {

    opacity: 1;

    transform:

      translateX(-50%)
      translateY(0)
      scale(1);

  }

}


/* =========================================================
   小标题
========================================================= */

.reward-subtitle {

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 14px;

  font-size: 13px;

  font-weight: 700;

  letter-spacing: 6px;

  color: #f4d982;

  text-shadow:

    0 0 8px #ffd84a,

    0 0 20px rgba(255, 180, 20, 0.7);

}


.reward-subtitle span:first-child,
.reward-subtitle span:last-child {

  font-size: 10px;

}


/* =========================================================
   奖励名称
========================================================= */

.reward-title {

  margin-top: 8px;

  font-size: 34px;

  font-weight: 900;

  color: #fff;

  text-shadow:

    0 0 5px #fff,

    0 0 15px #ffe16a,

    0 0 35px #ffae00,

    0 0 60px rgba(255, 140, 0, 0.8);

}


/* =========================================================
   数量
========================================================= */

.reward-number {

  margin-top: 4px;

  font-size: 20px;

  font-weight: 700;

  color: #ffe49b;

  text-shadow:

    0 0 10px
    rgba(255, 190, 50, 0.8);

}


/* =========================================================
   按钮
========================================================= */

.confirm-btn {

  position: relative;

  width: 190px;
  height: 52px;

  margin-top: 25px;

  padding: 0;

  border: 1px solid #f6d47a;

  border-radius: 4px;

  outline: none;

  overflow: hidden;

  cursor: pointer;

  background:

    linear-gradient(
      180deg,
      #dcb348,
      #936214
    );

  color: #fff;

  box-shadow:

    0 0 15px
    rgba(255, 190, 50, 0.55),

    inset 0 1px 0
    rgba(255, 255, 255, 0.6);

  transition:

    transform
    0.2s,

    box-shadow
    0.2s;

}


.confirm-btn:hover {

  transform:
    scale(1.05);

  box-shadow:

    0 0 25px
    rgba(255, 200, 60, 0.8),

    inset 0 1px 0
    rgba(255, 255, 255, 0.7);

}


.confirm-btn:active {

  transform:
    scale(0.96);

}


/* 按钮边框 */

.btn-border {

  position: absolute;

  inset: 4px;

  border:
    1px solid
    rgba(255, 240, 180, 0.4);

}


/* 按钮文字 */

.btn-text {

  position: relative;

  z-index: 3;

  font-size: 18px;

  font-weight: 700;

  letter-spacing: 6px;

}


/* 按钮高光 */

.btn-shine {

  position: absolute;

  left: -100%;

  top: 0;

  width: 50%;
  height: 100%;

  transform:
    skewX(-25deg);

  background:

    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.45),
      transparent
    );

  animation:

    button-shine

    2.5s

    1s

    infinite;

}


@keyframes button-shine {

  0% {
    left: -100%;
  }

  35%,
  100% {
    left: 150%;
  }

}


/* =========================================================
   跳过
========================================================= */

.skip {

  position: absolute;

  right: 35px;

  bottom: 28px;

  z-index: 100;

  padding: 8px 15px;

  font-size: 13px;

  color:
    rgba(255, 255, 255, 0.45);

  cursor: pointer;

  transition:
    color 0.2s;

}


.skip:hover {

  color:
    rgba(255, 255, 255, 0.9);

}


/* =========================================================
   Transition
========================================================= */

.reward-stage-enter-active,
.reward-stage-leave-active {

  transition:
    opacity
    0.3s
    ease;

}


.reward-stage-enter,
.reward-stage-leave-to {

  opacity: 0;

}


/* =========================================================
   手机适配
========================================================= */

@media screen and (max-width: 768px) {

  .card-scene {

    width: 240px;
    height: 345px;

  }


  .reward-info {

    top: calc(50% + 220px);

    width: 90%;

  }


  .card-image {

    width: 190px;
    height: 190px;

  }


  .reward-image {

    width: 150px;
    height: 150px;

  }


  .card-name {

    font-size: 20px;

  }


  .reward-title {

    font-size: 28px;

  }

}

</style>
```
